export function getter(obj, keys) {
  for (var i = 0; i < keys.length; i++) {
    if (!obj) return null;
    obj = obj[keys[i]];
  }
  if (typeof obj === 'object') {
    return JSON.stringify(obj);
  }
  return obj;
}